export default __webpack_public_path__ + "static/media/IMG_4433.e115ce82.jpg";